import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { httpPost } from "../../services/httpService";
import { getServicesByPostCodeUrl } from "../../apiUrls/apiUrls";
import { logErrorWithPayload } from "../../services/logService";
const initialState = {
  isServicesByPostCodeLoading: false,
  servicesByPostCode: [],
};
export const getServiceByPostCodeData = createAsyncThunk(
  "DOS/getServiceByPostCodeData",
  async (data) => {
    const url = getServicesByPostCodeUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
const dosSlice = createSlice({
  name: "dosSlice",
  initialState,
  reducers: {
    setServiceByPostCodeLoadingData: (state, action) => {
      state.isServicesByPostCodeLoading = action?.payload || false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getServiceByPostCodeData.pending, (state) => {
        state.isServicesByPostCodeLoading = true;
      })
      .addCase(getServiceByPostCodeData.fulfilled, (state, action) => {
        state.isServicesByPostCodeLoading = false;
        state.servicesByPostCode = action?.payload;
      })
      .addCase(getServiceByPostCodeData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isServicesByPostCodeLoading = false;
      });
  },
});
export const { setServiceByPostCodeLoadingData } = dosSlice.actions;
export default dosSlice.reducer;
